import React, { useState, useContext, useEffect } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames/bind';
import { StaticImage } from 'gatsby-plugin-image';
import Heading from 'components/shared/heading';
import Button from 'components/shared/button';
import Link from 'components/shared/link';

import MainContext from 'context/main';

import CloseIcon from 'icons/close-icon.inline.svg';

import styles from './popup-banner-product-demo.module.scss';

const cx = classNames.bind(styles);

const KEY_LOCAL_STORAGE = 'popup-banner-product-demo';

const PopupBannerProductDemo = ({ location, isCookieBannerVisible }) => {
  const [isOpen, setIsOpen] = useState(false);

  const { sharedBlocks } = useContext(MainContext);

  const { popupBannerProductDemo } = sharedBlocks || {};
  const { acf } = popupBannerProductDemo || {};
  const { title, description, buttonText, buttonUrl, showOnPages } = acf || {};

  const getLocalStorage = () => JSON.parse(localStorage.getItem(KEY_LOCAL_STORAGE));
  const setLocalStorage = (value) => localStorage.setItem(KEY_LOCAL_STORAGE, JSON.stringify(value));

  const handleOpen = () => {
    setIsOpen(true);
    setLocalStorage(true);
  };

  const handleButtonClose = () => {
    setIsOpen(false);
    setLocalStorage(false);
  };

  useEffect(() => {
    if (getLocalStorage() || getLocalStorage() === null) {
      const isShow = showOnPages?.some(({ uri: pageUrl }) => location.pathname === pageUrl);

      if (isShow) {
        handleOpen();
      }

      return null;
    }

    return null;
  }, [showOnPages, location.pathname]);

  return (
    <div className={cx('wrapper', { isOpen }, { isCookieBannerVisible })}>
      <div className={cx('content')}>
        <Link className={cx('title-wrapper')} to={buttonUrl}>
          <Heading className={cx('title')} size="md" tag="h5">
            {title}
          </Heading>
        </Link>
        {description && (
          <p className={cx('description')} dangerouslySetInnerHTML={{ __html: description }} />
        )}
      </div>
      <Button className={cx('button')} to={buttonUrl} size="sm" theme="accent-primary">
        {buttonText}
      </Button>

      <button className={cx('close')} type="button" onClick={handleButtonClose}>
        <CloseIcon />
      </button>
      <StaticImage
        className={cx('illustration')}
        src="./images/illustration.png"
        alt=""
        loading="eager"
        aria-hidden
      />
    </div>
  );
};

PopupBannerProductDemo.propTypes = {
  location: PropTypes.objectOf(PropTypes.any).isRequired,
  isCookieBannerVisible: PropTypes.bool.isRequired,
};

export default PopupBannerProductDemo;
